const r = "styles-module__inputError___W-Nid", t = {
  inputError: r
};
export {
  t as default,
  r as inputError
};
